import { useState, useEffect } from "react";
import { parseEther } from "ethers/lib/utils";
import { useContractRead, useNetwork } from "wagmi";
import { useIdle, useInterval } from "react-use";

// Utils
import { formatEtherNumber } from "utils/common";

// Configs
import { config } from "config/network";

type ConversionData = {
  conversionToBnb: number;
  conversionFromBnb: number;
};

const POLLING_INTERVAL = 10000;

const useConverstionRates = () => {
  const isIdle = useIdle(150e3);
  const { chain } = useNetwork();
  const [conversionRates, setConversionRates] = useState({} as ConversionData);

  const {
    data: conversionToBnb,
    isLoading: conversionToLoading,
    isError: conversionToError,
    refetch: conversionToRefetch,
  } = useContractRead({
    address: config.contractAddresses.xtoken.interactionPool,
    abi: config.abis.xtoken.interactionPool,
    functionName: "convertBnbXToBnb",
    chainId: +config.chainId,
    args: [parseEther("1")],
    structuralSharing: true,
  });

  const {
    data: conversionFromBnb,
    isLoading: conversionFromLoading,
    isError: conversionFromError,
    refetch: conversionFromRefetch,
  } = useContractRead({
    address: config.contractAddresses.xtoken.interactionPool,
    abi: config.abis.xtoken.interactionPool,
    functionName: "convertBnbToBnbX",
    chainId: +config.chainId,
    args: [parseEther("1")],
    structuralSharing: true,
  });

  useEffect(() => {
    if (
      !conversionToLoading &&
      !conversionFromLoading &&
      !conversionFromError &&
      !conversionToError &&
      conversionToBnb &&
      conversionFromBnb
    ) {
      setConversionRates({
        conversionToBnb: formatEtherNumber(
          conversionToBnb && conversionToBnb.toString(),
          10
        ),
        conversionFromBnb: formatEtherNumber(
          conversionFromBnb && conversionFromBnb.toString(),
          10
        ),
      });
    }
  }, [conversionToLoading, conversionFromLoading, chain]);

  useInterval(() => {
    if (!isIdle) {
      (async function refetchData() {
        await Promise.all([conversionFromRefetch(), conversionToRefetch()]);
      })();
    }
  }, POLLING_INTERVAL);

  return conversionRates;
};

export default useConverstionRates;
